import { render, staticRenderFns } from "./banners-index.vue?vue&type=template&id=224e5ae4&"
import script from "./banners-index.vue?vue&type=script&lang=js&"
export * from "./banners-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports